/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { Search } from '@manulife/mux-cds-icons';
import PropTypes from 'prop-types';
import { SVG_ICON_SIZE_DEFAULT } from '../../Icon/constants.js';
import TextInput from '../../TextInput/index.js';
import i18n from '../../../lang/i18n/index.js';
import { safeRest, rem } from '../../../utils/functions.js';
import { SearchFieldWrapper, IconWrapper } from './styledComponents.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useTheme from '../../../hooks/useTheme.js';
import useLang from '../../../hooks/useLang.js';
import { INPUT_VARIANT } from '../../TextInput/constants.js';

var _excluded = ["id", "placeholder", "icon"];
var SearchField = function SearchField(_ref) {
  var id = _ref.id,
    placeholder = _ref.placeholder,
    icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var lang = useLang();
  var safeProps = safeRest(rest);
  return /*#__PURE__*/jsxs(SearchFieldWrapper, {
    theme: theme,
    children: [/*#__PURE__*/jsx(IconWrapper, {
      children: icon || /*#__PURE__*/jsx(Search, {
        "aria-hidden": true,
        title: "search-icon",
        fontSize: rem(SVG_ICON_SIZE_DEFAULT),
        color: theme.sideNav.mobile.color
      })
    }), /*#__PURE__*/jsx(TextInput, _objectSpread({
      id: id,
      placeholder: placeholder || i18n[lang].utilityHeader.searchLabel,
      ariaLabel: i18n[lang].utilityHeader.searchLabel,
      variant: INPUT_VARIANT.BASIC_LINE,
      customStyle: {
        rootStyle: {
          width: '100%',
          marginRight: '20px'
        },
        inputStyle: {
          paddingLeft: '0'
        }
      }
    }, safeProps))]
  });
};
process.env.NODE_ENV !== "production" ? SearchField.propTypes = {
  /** id for the input DOM element */
  id: PropTypes.string,
  /** placeholder text for search field. All props from the TextInput component are also valid here */
  placeholder: PropTypes.string,
  /** icon for Search field */
  icon: PropTypes.node
} : undefined;
process.env.NODE_ENV !== "production" ? SearchField.displayName = 'SearchField' : undefined;

export { SearchField as default };
